import { render, staticRenderFns } from "./ed-create-product.component.vue?vue&type=template&id=953f04b8&scoped=true&"
import script from "./ed-create-product.component.ts?vue&type=script&lang=ts&"
export * from "./ed-create-product.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-create-product.component.scss?vue&type=style&index=0&id=953f04b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953f04b8",
  null
  
)

export default component.exports